import type { CSSProperties, ReactNode } from "react";
import { SidePanel } from "@hulahoop/ui";

export const SHELL_CONTENT_PANEL_CLASS =
  "relative mr-3 mb-3 ml-1 flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg border border-border bg-background";

export function ShellSidePanelFrame({
  side = "right",
  style,
  className,
  children,
}: {
  side?: "left" | "right";
  style?: CSSProperties;
  className?: string;
  children: ReactNode;
}) {
  return (
    <SidePanel side={side} style={style} className={className}>
      {children}
    </SidePanel>
  );
}
